import { themeQuartz } from "ag-grid-enterprise";

import { theme } from "@src/theme";

const CheckBox = {
  svg: '<svg viewBox="0 0 24 24" fill="red"><path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path></svg>',
};

export const gridTheme: typeof themeQuartz = themeQuartz
  .withParams({
    wrapperBorder: false,
    cellHorizontalPadding: 0,
    iconSize: 18,
    checkboxBorderRadius: 2,
    checkboxCheckedBorderColor: theme.igBorders.accent.default,
    checkboxBorderWidth: 2,
    checkboxCheckedShapeImage: CheckBox,
    focusShadow: false,
    rowHoverColor: "transparent",
    selectedRowBackgroundColor: "#F9FAFE",
    selectCellBackgroundColor: "#F9FAFE",
  })
  .withoutPart("checkboxStyle");
